<template>
  <div class="_modals">
    <b-modal
      id="modal-option"
      ref="resultActionModal"
      centered
      hide-footer
      :title="title"
    >
      <div class="modal-body">
        <div class="d-flex justify-content-center m-4">
          <img v-if="status === 'failed'" width="27" src="@/assets/image/icon/error-red.svg" alt="icon" />
        </div>

        <p class="text-center text-muted">{{ message }}</p>
      </div>
      <div class="d-flex justify-content-center w-100 pt-4 mb-4">
        <button
          @click="close()"
          class="button__bluecorporite mr-2 "
          style="border"
        >
          Close
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'OptionModal',
  data () {
    return {
      title: '',
      message: '',
      status: 'failed'
    }
  },
  created () {
    this.$eventHub.$on('dialog-result-action', this.dialogOption)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-result-action')
  },
  methods: {
    dialogOption ({ title, message, status }) {
      this.title = title
      this.message = message
      this.status = status
      this.$refs.resultActionModal.show()
    },

    close () {
      this.$refs.resultActionModal.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/ResultActionModal.vue